import { render, staticRenderFns } from "./FinancesCompensations.vue?vue&type=template&id=b398cb8a&scoped=true"
import script from "./FinancesCompensations.vue?vue&type=script&lang=js"
export * from "./FinancesCompensations.vue?vue&type=script&lang=js"
import style0 from "./FinancesCompensations.vue?vue&type=style&index=0&id=b398cb8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b398cb8a",
  null
  
)

export default component.exports